'use client';

import React from 'react';
import styled from '@emotion/styled';
import { Typography } from '@diritto/common/style/typography';
import { ButtonSize } from 'constants/button';
import { MagnifierIcon } from 'icons/ritto/Magnifier';
import { Error } from 'ui-components/common/Error';
import { HomeLinkButton } from 'ui-components/common/HomeLinkButton';

export const ErrorStatus401 = () => (
  <StyledWrap>
    <Error
      icon={<MagnifierIcon />}
      title={'페이지에 접근권한이 없어요.'}
      description={'권한이 필요한 페이지이거나,\n 현재 이용하실 수 없는 상태에요.\n(에러코드: 401)'}>
      <HomeLinkButton
        className={'no-underline'}
        label={'홈으로 가기'}
        buttonTypography={Typography.XXXSmall}
        size={ButtonSize.Small}
      />
    </Error>
  </StyledWrap>
);

const StyledWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 100px;
`;
